import { useSyncExternalStore } from 'react';

function getCurrentYear(): number {
  return new Date().getFullYear();
}

/** Client-only calendar year for copyright; SSR returns null to avoid hydration mismatch. */
export function useCurrentYear(): number | null {
  return useSyncExternalStore(
    () => () => {},
    getCurrentYear,
    () => null,
  );
}
